/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { ShimmerBadge, ShimmerButton } from 'react-shimmer-effects';

function UserListingHeaderSkeleton() {
    return (
        <div className="flex justify-between w-full">
            <h5 className="text-xs4 font-semibold text-[#555259]">
                <ShimmerBadge width={270} />
            </h5>
            <div className="flex">
                <div className="relative">
                    <ShimmerBadge width={180} />

                    {/* <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" /> */}
                </div>
                <div className="pl-2">
                    <ShimmerButton size="sm" />
                </div>
                <div className="pl-2 dropdown relative">
                    <ShimmerButton size="sm" />
                </div>
                <div className="pl-2">
                    <ShimmerButton size="sm" />
                </div>
            </div>

        </div>
    );
}

export default UserListingHeaderSkeleton;
